<!--
	LogoWide.svelte
-->

<script>
    import { push } from 'svelte-spa-router';
    const src = "img/logo_wide_reverse.png";

    const LANDING_PAGE = '/landing';

    const onLogoClick = () => {
        push(LANDING_PAGE);
    }
</script>

<style>
    .tcare-logo {
        width: 120px;
        color: var(--tcare-secondary);
        position: relative;
    }
    .tcare-logo img {
        max-height: 100%;
        max-width: 100%;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="tcare-logo flex-center" on:click={onLogoClick}>
    <img {src} alt="TCARE logo" draggable="false"/>
</div>
